import * as actionTypes from "./actionTypes";
import voucherService from "services/voucherService";


export const findVoucherByCode = code => {
  return dispatch => {
    voucherService.findVoucherByCode(code)
      .then(data => {
        dispatch(successLinkVoucherRequest(data))
      })
      .catch(err => {
        console.log(err)
      })
  }
}

const successLinkVoucherRequest = voucher => {
  return {
    type: actionTypes.LINK_VOUCHER_LOAD,
    payload: voucher
  };
};




// WEBPACK FOOTER //
// ./src/store/actions/LinkVoucher.js